
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/glossary/[WinningMetricDetails]",
      function () {
        return require("private-next-pages/glossary/[WinningMetricDetails].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/glossary/[WinningMetricDetails]"])
      });
    }
  